<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
      <el-backtop :bottom="200" class="backtop">
        <img width="26" height="36" src="../../assets/images/top.png" >
      </el-backtop>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
.backtop{
  width: 39px;
  height: 58px;
  background: rgba(43,104,255,0.8);
  box-shadow: 0px 0px 10px 0px rgba(0, 5, 39, 0.2);
  // opacity: 0.8;
  border-radius: 4px 0px 0px 4px;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue